import { getLinks } from "../../../../shared/functions/fns.nav";
import Loader from "@phoenixreisen/mithrils/src/loader";
import User from "@phoenixreisen/user";
import m from "mithril";
import { ensureValidToken } from "@phoenixreisen/frontend-lib";
function intranetOnly(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    alert("Diese Anwendung ist nur innerhalb des Phoenix Netzwerks verfügbar und muss deshalb über das Testsystem aufgerufen werden.");
}
export const Hub = {
    oninit({ state }) {
        state.links = null;
        state.loading = true;
        ensureValidToken({
            overwriteApiUrl: `${process.env.GATEWAY}/call-json-service`,
        }).then((isAuthed) => {
            if (!isAuthed) {
                m.route.set("/");
            }
        });
        getLinks()
            .then((result) => {
            state.links = result;
        })
            .catch(() => {
            m.route.set("/error");
        })
            .finally(() => {
            state.loading = false;
            m.redraw();
        });
    },
    view({ state }) {
        var _a, _b, _c;
        const { loading, links } = state;
        if (loading) {
            return m(Loader, null);
        }
        return (m("section", { class: "hub-page" },
            m("div", null,
                m("h3", { class: "pt1 pb1" },
                    "Hallo ",
                    User.getPhxUsername(),
                    "!",
                    m("br", null),
                    "Wo m\u00F6chtest du hin?"),
                m("h4", null, "Workspace Anwendungen"),
                m("div", { class: "cards" }, (_a = links.WORKSPACE) === null || _a === void 0 ? void 0 : _a.map((link) => {
                    if (link.category === "application") {
                        if (link.type === "intranet" &&
                            !location.href.includes("intern")) {
                            return (m("a", { href: "javascript:", onclick: intranetOnly, class: "card" },
                                m("i", { class: "fas fa-arrow-right ml2" }),
                                m("span", null, link.name)));
                        }
                        return (m("a", { href: link.href, class: "card" },
                            m("i", { class: "fas fa-arrow-right ml2" }),
                            m("span", null, link.name)));
                    }
                    return null;
                })),
                m("h4", null, "Externe Angebote"),
                m("div", { class: "cards" }, (_b = links.PUBLIC) === null || _b === void 0 ? void 0 : _b.map((link) => {
                    return (m("a", { href: link.href, class: "card" },
                        m("i", { class: "fas fa-arrow-right ml2" }),
                        m("span", null, link.name)));
                })),
                m("h4", null, "Dein Account"),
                m("div", { class: "cards" }, (_c = links.WORKSPACE) === null || _c === void 0 ? void 0 : _c.map((link) => {
                    if (link.category === "account") {
                        return (m("a", { href: link.href, class: "card" },
                            m("i", { class: "fas fa-arrow-right ml2" }),
                            m("span", null, link.name)));
                    }
                    return null;
                })))));
    },
};
export default Hub;
